import { useEffect, useState } from 'react';
import { FriendshipRequest } from '@/api';
import { useSession } from '@/Session';
import { CopyIcon, CopiedIcon } from '@/icons';

const MyFriendshipRequest = () => {
  const {
    document: { user },
  } = useSession();
  const [message, setMessage] = useState('');
  const [token, setToken] = useState('');
  const [copied, setCopied] = useState(false);
  const [successClass, setSuccessClass] = useState('bg-none');

  useEffect(() => {
    const friendshipRequest = new FriendshipRequest({ message });
    const timer = setTimeout(async () => {
      const success = await friendshipRequest.save();
      setToken(success ? friendshipRequest.token : '');
      setSuccessClass(success ? 'bg-success' : 'bg-error');
    }, 500);
    return () => clearTimeout(timer);
  }, [message, user.name]);
  useEffect(() => {
    setCopied(false);
  }, [token]);

  useEffect(() => {
    if (successClass === 'bg-success') {
      const timer = setTimeout(() => {
        setSuccessClass('bg-none');
      }, 500);
      return () => clearTimeout(timer);
    }
  }, [successClass]);

  const copyToken = () => {
    navigator.clipboard.writeText(token).then(() => setCopied(true));
  };

  return (
    <div>
      <label className='input'>
        Message
        <input
          type='text'
          className={`grow`}
          placeholder='Message'
          value={message}
          onChange={({ target }) => setMessage(target.value)}
        />
      </label>
      <label className='input'>
        Token
        <input
          type='text'
          className={`grow ${successClass}`}
          placeholder='Token'
          value={token}
          onChange={() => {}}
          disabled
        />
        <button
          onClick={copyToken}
          className='btn btn-primary'
          disabled={token === ''}
        >
          {copied ? <CopiedIcon /> : <CopyIcon />}
        </button>
      </label>
    </div>
  );
};

export default MyFriendshipRequest;
